import {
  AsyncFilterableSinglePicker as LibAsyncFilterableSinglePicker,
  AsyncFilterableSinglePickerProps as LibAsyncFilterableSinglePickerProps,
} from "@flaminem/ui-components";

import { useT } from "src/internationalization";

export type AsyncFilterableSinglePickerProps<TItem> = Omit<
  LibAsyncFilterableSinglePickerProps<TItem>,
  "languageTexts"
>;

export function AsyncFilterableSinglePicker<TOption>(
  props: AsyncFilterableSinglePickerProps<TOption>
) {
  const t = useT();

  return (
    <LibAsyncFilterableSinglePicker
      languageTexts={{
        errorLoadingOptions: t("general.info.error.loading.options"),
        noOptions: t("general.info.no.options"),
        emptySearch: t("general.info.start.typing.to.search"),
      }}
      {...props}
    />
  );
}
